import React, { useContext, useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { Button, Form, FormGroup, Label, Col } from "reactstrap";
// import Datepicker from 'react-datepicker';
import Select from "react-select";
import Datetime from "react-datetime";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { Get, JENIS_DUSUN, Post } from "../../function/Koneksi";
import { generateAlamat, Tanggal } from "../../function/Format";

const ModalSuratAhliWaris = ({
  data,
  optionData,
  setAlert,
  isOpen,
  setIsOpen,
  statusRefresh,
  setStatusRefresh,
  propsData,
  kiosk
}) => {
  const dateFormat = require("dateformat");

  const frmDex = {
    uuid: "",
    id_jenis: "",
    nik_pelapor: "",
    nik: "",
    kk: "",
    nama: "",
    tempat_lahir: "",
    tanggal_lahir: "",
    jenis_kelamin: "",
    pekerjaan: "",
    pendidikan_terakhir: "",
    kewarganegaraan: "",
    agama: "",
    alamat: "",
    alamat_kk: "",
    alamat_kk2: "",
    status_perkawinan: "",
    waktu_meninggal: "",
    tempat_meninggal: "",
    tgl_dikebumikan: "",

    nik2: "",
    nama2: "",
    tempat_lahir2: "",
    tanggal_lahir2: "",
    jenis_kelamin2: "",
    pekerjaan2: "",
    pendidikan_terakhir2: "",
    kewarganegaraan2: "",
    agama2: "",
    alamat2: "",
    alamat_kk3: "",
    status_perkawinan2: "",
    waktu_meninggal2: "",
    tempat_meninggal2: "",
    tgl_dikebumikan2: "",
    detail: [],

    nik_ahli_waris: "",
    nama_ahli_waris: "",
    jk_ahli_waris: "",
    tempat_lahir_ahli_waris: "",
    alamat_ahli_waris: "",
    alamat_kk4: "",
    pekerjaan_ahli_waris: "",
    shdk_ahli_waris: "",
    tgl_lahir_ahli_waris: new Date()
  };

	const initFormData = {
		frmNik: optionData.frmNik,
    frmPkr: optionData.frmPkr,
		frmShdk: optionData.frmShdk,
		frmNik3: optionData.frmNik3,
		nikStat: null,
		nikStatMeninggal: null,
		nik2Stat: null,
		nik3Stat: null,
		shdk_aw: null,
		detail: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPelapor: "none",
			dataPenduduk: "none",
			dataPenduduk2: "none",
      ahliWarisManual: "none",
      frmPreviewDraft: false,
		},
		meninggal: "none",
		meninggal2: "none",
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
    formAhliWaris: "none",
    // Preview surat
		get_data_surat:[],
		get_jenis_surat: "",
	}

  const [formData, setFormData] = useState(initFormData);
  const [props, setProps] = useState(propsData);
  const [kioskMode, setKioskMode] = useState(kiosk)
  const [dt, setDt] = useState(data ? data : frmDex);

  useEffect(() => {
    if (document.getElementById("modalForm")) {
      document.getElementById("modalForm").reset();
    }

    setDt(data ? data : frmDex);
    setFormData(
      data
        ? {
            ...initFormData,
            nikStat: optionData.nikStat,
            nikStatMeninggal: optionData.nikStatMeninggal,
            nik2Stat: optionData.nik2Stat,
            frmNik2: optionData.frmNik2,
            frmNik3: optionData.frmNik3,
            frmPkr: optionData.frmPkr,
            formAhliWaris: optionData.formAhliWaris,
            meninggal: optionData.meninggal,
            meninggal2: optionData.meninggal2,
            status: optionData.status
          }
        : initFormData
    );
  }, [isOpen]);

  const requireTanggalAhliWaris = () => {
    if (formData.formAhliWaris === "none") {
      return false;
    } else {
      return true;
    }
  };

  const handleSelectChange = (e, fld) => {
    if (e) {
      // console.log("ini handle select", dt)
      setDt({
        ...dt,
        [fld]: e
      });
    }
    else{
      setDt({
        ...dt,
        [fld]: ""
      })
    }
  };

  const handleInputChange = (e, fld) => {
    setDt({
      ...dt,
      [fld]: e.target.value
    });
  };

  const handleInputChangeNIK = (e, fld) => {
    if (e && kioskMode == false) {
      let nikStat = { value: e, label: e };

      Post("penduduk", null, { nik: e }, datanik => {
        let frmNik = [];
        datanik.data.results.data.forEach(dt => {
          frmNik.push({ value: dt.id, label: dt.id + " (" + dt.nama + ")" });
        });

        switch (fld) {
          case "nik":
            setFormData({
              ...formData,
              frmNik,
              nikStat
            });
            break;
          case "meninggal":
            setFormData({
              ...formData,
              frmNik2: frmNik,
              nikStatMeninggal: nikStat
            });
            break;
          case "nik2":
            setFormData({
              ...formData,
              frmNik2: frmNik,
              nik2Stat: nikStat
            });
            break;

          default:
            break;
        }
      });
    }
  };

  const dataAhliWaris = () => {
    let ahliWarisManual = "block";

    let formAhliWaris = formData.formAhliWaris === "" ? "none" : "";

    if (formAhliWaris !== "") {
      ahliWarisManual = "none";
    }

    setDt({
      ...dt,
      // detail: [],
      nik_ahli_waris: "",
      nama_ahli_waris: "",
      jk_ahli_waris: null,
      tgl_lahir_ahli_waris: null,
      tempat_lahir_ahli_waris: "",
      pekerjaan_ahli_waris: null,
      shdk_ahli_waris: ""
    });

    setFormData({
      ...formData,
      status: {
        ...formData.status,
        ahliWarisManual
      },
      formAhliWaris,
      nik3Stat: null
    });
  };

  // console.log("nikstat2");
  const changeInputText = (e, fld) => {
    switch (fld) {
      case "penghasilan":
        setDt({
          ...dt,
          penghasilan: e.target.value
        });
        break;
      default:
        // no default
        break;
    }
  };
  // console.log("e", )
  // console.log("dt", dt);
  const getPenduduk = (e, sel, jns) => {
    if (e) {
      // this.changeSelectValue(e, sel);
      if (kioskMode) {
        props.setLoadingPreview(true)
      }
      else{
        setAlert({
          loadingPreview: true
        })
      }

			Get("penduduk/find", e.value, data => {
        const alamat = generateAlamat(data.results);
        let alamat_kk = "";
    
        if(data.results.data_kk){
          alamat_kk = data.results.data_kk.alamat
        }

        if (jns === "pelapor") {
          Get("penduduk/kk/" + data.results.id_kk, null, dtkk => {
            let frmNik3 = [];
            dtkk.results.forEach(val => {
              frmNik3.push({
                value: val.id,
                label: val.id + " (" + val.nama + ")"
              });
            });

            setFormData({
              ...formData,
              meninggal:"block",
              nikStat: e,
              frmNik2: frmNik3,
              frmNik3,
              status: {
                ...formData.status,
                dataPelapor: "block",
              },
            });
            setDt({
              ...dt,
              nik: e.value,
              nik_pelapor: e.value,
              kk: data.results.id_kk,
              nama: data.results.nama,
              nama_pemohon: data.results.nama,
              tempat_lahir: data.results.tempat_lahir,
              tanggal_lahir: new Date(data.results.tanggal_lahir),
              pekerjaan: data.results.data_pekerjaan.nama,
              pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
              agama: data.results.data_agama.nama,
              status_perkawinan: data.results.status_perkawinan,
              jenis_kelamin: data.results.jk,
              alamat: alamat,
              alamat_kk: alamat_kk,
              kewarganegaraan: "WNI",
              detail: []
            });
            
            if (kioskMode) {
              props.setLoadingPreview(false)
            }
            else{
              setAlert({
                loadingPreview: false
              })
            }

						// For testing
						// if (props.selectOnChange2) {
						// 	props.selectOnChange2(dt)
						// }

					});

				} else if (jns === "meninggal") {
          setFormData({
						...formData,
						nikStatMeninggal: e,
						status: {
							...formData.status,
							dataPenduduk: "block",
						},
					})
					setDt({
						...dt,
						nik_meninggal: e.value,
						nama_meninggal: data.results.nama,
						tempat_lahir_meninggal: data.results.tempat_lahir,
						tanggal_lahir_meninggal: new Date(
							data.results.tanggal_lahir
						),
						pekerjaan_meninggal: data.results.data_pekerjaan.nama,
						pendidikan_terakhir_meninggal: data.results.data_pendidikan_terakhir.nama,
						agama_meninggal: data.results.data_agama.nama,
						status_perkawinan_meninggal: data.results.status_perkawinan,
						jenis_kelamin_meninggal: data.results.jk,
						alamat_meninggal: alamat,
						alamat_kk2: alamat_kk,
						kewarganegaraan_meninggal: 'WNI',
					})

          if (kioskMode) {
            props.setLoadingPreview(false)
          }
          else{
            setAlert({
              loadingPreview: false
            })
          }
				} else if (jns === "meninggal2") {
					setFormData({
						...formData,
						nik2Stat: e,
						status: {
							...formData.status,
							dataPenduduk2: "block",
						},
					})
					setDt({
						...dt,
						nik_meninggal2: e.value,
						nama_meninggal2: data.results.nama,
						tempat_lahir_meninggal2: data.results.tempat_lahir,
						tanggal_lahir_meninggal2: new Date(
							data.results.tanggal_lahir
						),
						pekerjaan_meninggal2: data.results.data_pekerjaan.nama,
						pendidikan_terakhir_meninggal2: data.results.data_pendidikan_terakhir.nama,
						agama_meninggal2: data.results.data_agama.nama,
						status_perkawinan_meninggal2: data.results.status_perkawinan,
						jenis_kelamin_meninggal2: data.results.jk,
						alamat_meninggal2: alamat,
						alamat_kk3: alamat_kk,
						kewarganegaraan2: 'WNI',
					})
					
          if (kioskMode) {
            props.setLoadingPreview(false)
          }
          else{
            setAlert({
              loadingPreview: false
            })
          }
          
				} else if (jns === "pengikut") {
					let detail = dt.detail
					detail.push({
						nik: e.value,
						nama: data.results.nama,
						jenis_kelamin: data.results.jk,
						tanggal_lahir: data.results.tanggal_lahir,
						tempat_lahir: data.results.tempat_lahir,
						pekerjaan: data.results.data_pekerjaan.nama,
						// shdk: formData.frmShdk[data.results.shdk],
            alamat: alamat,
            alamat_kk: alamat_kk,
            shdk: data.results.data_shdk.nama,
						keterangan: "",
					})

					setDt({
						...dt,
						detail
					})

          if (kioskMode) {
            props.setLoadingPreview(false)
          }
          else{
            setAlert({
              loadingPreview: false
            })
          }

          // For testing
          // if (this.props.getListNIK3) {
          // 	this.props.getListNIK3(frmNik3)
          // }
        }
      });
    } else {
      switch (jns) {
        case "pelapor":
          setDt({
            ...dt,
            nama_meninggal:'',
            tempat_lahir_meninggal:'',
            tanggal_lahir_meninggal:'',
            waktu_meninggal:'',
            tempat_meninggal:'',
            tgl_dikebumikan:'',
            nama_meninggal2:'',
            tempat_lahir_meninggal2:'',
            tanggal_lahir_meninggal2:'',
            waktu_meninggal2:'',
            tempat_meninggal2:'',
            tgl_dikebumikan2:'',
          })
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              dataPelapor: "none",
              dataPenduduk:"none",
              dataPenduduk2:"none",
            },
            meninggal:"none",
            meninggal2:"none",
            nikStat: null,
            nikStatMeninggal: null,
            nik2Stat: null,
            frmNik2: [],
            frmNik3: []
          });
          break;
        case "meninggal":
          setDt({
            ...dt,
            waktu_meninggal: "",
            tempat_meninggal: "",
            tgl_dikebumikan: ""
          });
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              dataPenduduk: "none"
            },
            nikStatMeninggal: null,
          });
          break;
        case "meninggal2":
          setDt({
            ...dt,
            nama2: "",
            tanggal_lahir2: "",
            tempat_lahir2: "",
            agama2: "",
            pekerjaan2: "",
            kewarganegaraan2: "",
            alamat2: "",
            alamat_kk3: "",
            jenis_kelamin2: "",
            status_perkawinan2: "",
            waktu_meninggal2: "",
            tempat_meninggal2: "",
            tgl_dikebumikan2: ""
          });
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              dataPenduduk2: "none"
            },
            nik2Stat: null,
          });
          break;
        case "pengikut":
          setFormData({
            ...formData,
            nik3Stat: null
          });
          break;
        default:
          break;
      }
    }
  };

  const hapusDetail = i => {
    // console.log(i);
    // let currDetail = dt.detail
    let newDetail = dt.detail.splice(i, 1);

    // console.log(currDetail);
    // console.log(newDetail);
    // console.log(dt.detail);

    setDt({
      ...dt,
      detail: dt.detail
    });
  };

  const tambahMeninggal = e => {
    // e.preventDefault();
    if (formData.meninggal2 === "none") {
      setDt({
        ...dt,
        nama2: "",
        tanggal_lahir2: "",
        tempat_lahir2: "",
        agama2: "",
        pekerjaan2: "",
        kewarganegaraan2: "",
        alamat2: "",
        alamat_kk3: "",
        jenis_kelamin2: "",
        status_perkawinan2: "",
        waktu_meninggal2: "",
        tempat_meninggal2: "",
        tgl_dikebumikan2: ""
      });
      setFormData({
        ...formData,
        meninggal2: "inherit",
        nik2Stat: null,
        status: {
          ...formData.status,
          dataPenduduk2: "none"
        }
      });
    } else {
      setDt({
        ...dt,
        nama2: "",
        tanggal_lahir2: "",
        tempat_lahir2: "",
        agama2: "",
        pekerjaan2: "",
        kewarganegaraan2: "",
        alamat2: "",
        alamat_kk3: "",
        jenis_kelamin2: "",
        status_perkawinan2: ""
      });
      setFormData({
        ...formData,
        meninggal2: "none",
        nik2Stat: null,
        status: {
          ...formData.status,
          dataPenduduk2: "none"
        }
      });

      // this.state.status.dataPenduduk2 = "none";
      // this.setState({
      //   meninggal2: "none",
      //   nik2Stat: null,
      // });
      // this.forceUpdate();
    }
  };

  const tambahwaris = e => {
    e.preventDefault();

		if (kioskMode) {
			props.setLoadingPreview(true)
		}
    else{
      setAlert({
        loadingPreview: true
      })
    }

    let cekForm = false;
    
    if(dt.nik_ahli_waris && 
      dt.nama_ahli_waris && 
      dt.jk_ahli_waris &&
      dt.tgl_lahir_ahli_waris &&
      dt.tempat_lahir_ahli_waris &&
      dt.alamat_ahli_waris &&
      dt.pekerjaan_ahli_waris &&
      dt.shdk_ahli_waris
    ){
      cekForm = true
    }

    if(cekForm){
      let detail = dt.detail;
      detail.push({
        nik: dt.nik_ahli_waris,
        nama: dt.nama_ahli_waris,
        jenis_kelamin: dt.jk_ahli_waris.value,
        tanggal_lahir: dateFormat(new Date(dt.tgl_lahir_ahli_waris), "yyyy-mm-dd"),
        tempat_lahir: dt.tempat_lahir_ahli_waris,
        alamat: dt.alamat_ahli_waris,
        alamat_kk: formData.formAhliWaris === "none" ? dt.alamat_kk4 : dt.alamat_ahli_waris,
        pekerjaan: dt.pekerjaan_ahli_waris.label,
        shdk: dt.shdk_ahli_waris.label,
        keterangan: ""
      });
      setDt({
        ...dt,
        detail,
        nik_ahli_waris: "",
        nama_ahli_waris: "",
        jk_ahli_waris: null,
        tgl_lahir_ahli_waris: null,
        tempat_lahir_ahli_waris: "",
        pekerjaan_ahli_waris: null,
        shdk_ahli_waris: ""
      });
      setFormData({
        ...formData,
        status: {
          ...formData.status,
          ahliWarisManual: "none"
        },
        formAhliWaris: "none",
        nik3Stat: null
      });

      if (kioskMode){
				props.setLoadingPreview(false)
			}
      else{
        setAlert({
          loadingPreview: false
        })
      }
    }
    else{
      if (kioskMode){
				props.getAntrian('Surat Keterangan Ahli Waris Pandau', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				setAlert({
					loadingPreview: false
				})
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert(alertData)
			}
    }
  };

  const simpan = e => {
    e.preventDefault();

    if (kioskMode){
      props.setLoadingPreview(true)
    }
    else{
      setAlert({
        loadingPreview: true
      })
    }

    let validasiMeninggal = false;
    let validasiMeninggal2 = false;
    if(formData.meninggal2 !== "none" || ""){
      if(formData.nik2Stat){
        validasiMeninggal2 = true
      }
    }else{
      validasiMeninggal2 = true
    }
    
    if(formData.nikStatMeninggal){
      if(document.getElementById("tempat_meninggal").value && dt.waktu_meninggal && dt.tgl_dikebumikan){
        validasiMeninggal = true
      }
    }

    if (formData.nikStat && formData.nikStatMeninggal && validasiMeninggal && validasiMeninggal2 && dt.detail.length > 0) {
      let dataMeninggal2 = null;

      let bodyRaw = {
        ...dt,
        tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir), "yyyy-mm-dd"),
        tempat_meninggal2: document.getElementById("tempat_meninggal2").value,
        tujuan_pembuatan:'-',
      };

      let dataMeninggal = {
        nama: dt.nama_meninggal,
        tempat_lahir: dt.tempat_lahir_meninggal,
        tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir_meninggal), "yyyy-mm-dd"),
        pekerjaan: dt.pekerjaan_meninggal,
        jenis_kelamin: dt.jenis_kelamin_meninggal,
        nik: dt.nik_meninggal,
        alamat: dt.alamat_meninggal,
        alamat_kk: dt.alamat_kk2,
        tanggal_meninggal: dateFormat(new Date(dt.waktu_meninggal),"yyyy-mm-dd"),
        dikebumikan: document.getElementById("tempat_meninggal").value,
        tanggal_dikebumikan: dateFormat(new Date(dt.tgl_dikebumikan),"yyyy-mm-dd"),

      }

      if (formData.nik2Stat) {
        dataMeninggal2 = {
          nama: dt.nama_meninggal2,
          tempat_lahir: dt.tempat_lahir_meninggal2,
          tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir_meninggal2), "yyyy-mm-dd"),
          pekerjaan: dt.pekerjaan_meninggal2,
          jenis_kelamin: dt.jenis_kelamin_meninggal2,
          nik: dt.nik_meninggal2,
          alamat: dt.alamat_meninggal2,
          alamat_kk: dt.alamat_kk3,
          tanggal_meninggal: dateFormat(new Date(dt.waktu_meninggal2),"yyyy-mm-dd"),
          dikebumikan: document.getElementById("tempat_meninggal2").value,
          tanggal_dikebumikan: dateFormat(new Date(dt.tgl_dikebumikan2),"yyyy-mm-dd"),
        }
      }
      // Jika ada tambahan data meninggal

      let detail_surat = {
        data_ahli_waris: dt.detail,
        data_meninggal: dataMeninggal,
        data_meninggal2: dataMeninggal2,
      };

      // Set Detail Surat pada BodyRaw
      bodyRaw = {
        ...bodyRaw,
        detail_surat: JSON.stringify(detail_surat),
      }

      // delete data meninggal2 from body raw
      delete bodyRaw.nik2;
      delete bodyRaw.nama2;
      delete bodyRaw.tempat_lahir2;
      delete bodyRaw.tanggal_lahir2;
      delete bodyRaw.jenis_kelamin2;
      delete bodyRaw.pekerjaan2;
      delete bodyRaw.pendidikan_terakhir2;
      delete bodyRaw.kewarganegaraan2;
      delete bodyRaw.agama2;
      delete bodyRaw.alamat2;
      delete bodyRaw.alamat_kk3;
      delete bodyRaw.status_perkawinan2;
      delete bodyRaw.waktu_meninggal2;
      delete bodyRaw.tempat_meninggal2;
      delete bodyRaw.tgl_dikebumikan2;

      if (dt.uuid === "") {
        if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
      }
      // console.log(bodyRaw);

      let psn = "";
      let resstat = 204;
      let metode = "create";
      if (bodyRaw.uuid === "") {
        psn = "Tambah";
        resstat = 201;
        bodyRaw.uuid = null;
      } else {
        psn = "Ubah";
        resstat = 200;
        metode = "update";
      }
      
      Post(
				"surat-keterangan/grup/" + metode,
				bodyRaw.uuid,
				bodyRaw,
				res => {
          // For testing
          if (props.resSubmit) {
            props.resSubmit(res.status);
          }
          // this.tutupForm();
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              btnForm: false,
              form: false
            }
          });
          setIsOpen(false);

          if (kioskMode) {
            if (res.status === resstat) {
              let dataAntrian = {
                nama: props.data.results.nama,
                nik: props.data.results.id,
                keterangan: '',
                uuid_surat:res.data.results.uuid_surat,
                kode_surat:res.data.results.kode_surat,
              };
    
              // Set Data Surat
              props.getDataSurat(res.data.results);

              setTimeout(function () {
                Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {

                  props.setLoadingPreview(false)

                  if (res2.code === 201) {
                    props.getAntrian('Surat Keterangan Ahli Waris Pandau', 'berhasil', false, dataAntrian);
                  }
                  else {
                    props.getAntrian('Surat Keterangan Ahli Waris Pandau', 'gagal');
                  }
                });
              }.bind(this),1000)
            }
            else{
              props.setLoadingPreview(false)
              props.getAntrian('Surat Keterangan Ahli Waris Pandau', 'gagal');
            }
					} else {
            if (res.status === resstat) {
              const alertData = {
                get_data_surat:{
                  uuid_surat:res.data.results.uuid_surat,
                  kode_surat:res.data.results.kode_surat,
                },
                status:{
                  frmPreviewDraft: true,
                  jenis_form: psn,
                }
                // show: true,
                // basicType: "success",
                // basicTitle: "Data Surat Keterangan Ahli Waris",
                // pesanAlert: "Berhasil " + psn + " Data",
                // successAlert: true
              };
              setAlert({
                loadingPreview: false
              })
              setAlert(alertData);
            } else {
              const alertData = {
                show: true,
                basicType: "danger",
                basicTitle: "Data Surat Keterangan Ahli Waris",
                pesanAlert: "Gagal " + psn + " Data"
              };
              setAlert({
                loadingPreview: false
              })
              setAlert(alertData);
            }
            // Refresh list
            setStatusRefresh(true);
          }
        }
      );
    } else {
      if (kioskMode){
				props.getAntrian('Surat Keterangan Ahli Waris Pandau', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
        setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
    }
  };
  // console.log("status", formData.status);
  // console.log("nikstat", formData.nikStat);
  // console.log("dt", dt.detail);
  // console.log("shdk", formData.frmShdk);
  // console.log("pkr", formData.frmPkr);
  return (
    <Modal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      style={{
        maxwidth: "unset"
      }}
      styles={{
      	// modal: {
      		width: '100%',
      		// minWidth: '301px'
      	// }
      }}
    >
      <Form data-testid="form-create" className="theme-form" onSubmit={simpan}>
        <div className="modal-header">
          <h5 className="modal-title">
            {dt.uuid == "" ? "Tambah" : "Edit"} Surat Keterangan Ahli Waris
          </h5>
        </div>
        <div className="modal-body">
          <p>
            Data identitas akan terisi secara otomatis saat NIK dipilih. Jika
            ada ketidak sesuaian data, silakan ubah di data master penduduk.
          </p>
          <input
            className="form-control"
            id="uuid"
            type="hidden"
            placeholder=""
            defaultValue={dt.uuid}
          />
          <FormGroup className="row">
            <Col sm="12">
              <Label className="col-form-label" htmlFor="nik">
                <b>NIK Penduduk</b>
              </Label>
              <div data-testid="selectNIK">
                <Select
                  inputId="nik"
                  classNamePrefix="select"
                  onChange={e => {
                    getPenduduk(e, "nik", "pelapor");
                  }}
                  defaultValue={formData.nikStat}
                  value={formData.nikStat}
                  name="NIK"
                  options={formData.frmNik}
                  placeholder="Pilih NIK"
                  onInputChange={e => handleInputChangeNIK(e, "nik")}
                  isClearable
                />
              </div>
            </Col>
          </FormGroup>
          <div style={{ display: formData.status.dataPelapor }}>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Nama Penduduk</b>
                </Label>
                <input
                  className="form-control"
                  id="nama"
                  type="text"
                  placeholder="Nama Pemohon"
                  value={dt.nama}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Tempat Lahir</b>
                </Label>
                <input
                  className="form-control"
                  id="tempat_lahir"
                  type="text"
                  placeholder="Tempat Lahir"
                  value={dt.tempat_lahir}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Tanggal Lahir</b>
                </Label>
                <input
                  className="form-control"
                  id="tanggal_lahir"
                  type="text"
                  placeholder="Tanggal Lahir"
                  value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Alamat</b>
                </Label>
                <input
                  className="form-control"
                  id="alamat_kk"
                  type="text"
                  placeholder="Alamat"
                  value={dt.alamat_kk}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Wilayah</b>
                </Label>
                <input
                  className="form-control"
                  id="alamat"
                  type="text"
                  placeholder="Alamat"
                  value={dt.alamat}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
          </div>
          <div style={{ display: formData.meninggal }}>
            <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Penduduk Meninggal</b>
						</div>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="] col-form-label" htmlFor="nik_meninggal">
                  <b>NIK Penduduk</b>
                </Label>
                <div data-testid="selectNIK2">
                  <Select
                    inputId="nik_meninggal"
                    classNamePrefix="select"
                    onChange={e => {
                      getPenduduk(e, "nik", "meninggal");
                    }}
                    defaultValue={formData.nikStatMeninggal}
                    value={formData.nikStatMeninggal}
                    name="NIK2"
                    options={formData.frmNik2}
                    placeholder="Pilih NIK"
                    // onInputChange={e => handleInputChangeNIK(e, "nik2")}
                    isClearable
                  />
                </div>
              </Col>
            </FormGroup>
            <div style={{ display: formData.status.dataPenduduk }}>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Nama Penduduk</b>
                  </Label>
                  <input
                    className="form-control"
                    id="nama_meninggal"
                    type="text"
                    placeholder="Nama Pemohon"
                    value={dt.nama_meninggal}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tempat Lahir</b>
                  </Label>
                  <input
                    className="form-control"
                    id="tempat_lahir_meninggal"
                    type="text"
                    placeholder="Tempat Lahir"
                    value={dt.tempat_lahir_meninggal}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tanggal Lahir</b>
                  </Label>
                  <input
                    className="form-control"
                    id="tanggal_lahir_meninggal"
                    type="text"
                    placeholder="Tanggal Lahir"
                    value={new Date(dt.tanggal_lahir_meninggal).toLocaleDateString(
                      "id-ID"
                    )}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className=" col-form-label" htmlFor="inputEmail3">
                    <b>Alamat</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_kk2"
                    type="text"
                    placeholder="Alamat"
                    value={dt.alamat_kk2}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className=" col-form-label" htmlFor="inputEmail3">
                    <b>Wilayah</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_meninggal"
                    type="text"
                    placeholder="Alamat"
                    value={dt.alamat_meninggal}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tanggal Meninggal</b>
                  </Label>
                  <Datetime
                    inputProps={{
                      "data-testid": "waktu_meninggal",
                      placeholder: "Tanggal Meninggal",
                      // required: true
                    }}
                    inputId="waktu_meninggal"
                    name="waktu_meninggal"
                    id="waktu_meninggal"
                    locale="id-ID"
                    dateFormat="DD/MM/yyyy"
                    timeFormat={false}
                    input={true}
                    closeOnTab={true}
                    initialValue={new Date(dt.waktu_meninggal)}
                    value={new Date(dt.waktu_meninggal)}
                    required
                    // required={formData.status.dataPenduduk !== "none" ? true : false}
                    onChange={date => {
                      if (typeof date._isValid !== "undefined") {
                        let tgl = date.format("YYYY-MM-DD");
                        setDt({
                          ...dt,
                          waktu_meninggal: new Date(tgl)
                        });
                      }
                    }}
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Dikebumikan di</b>
                  </Label>
                  <input
                    data-testid="tempat meninggal"
                    name="tempat_meninggal"
                    className="form-control"
                    id="tempat_meninggal"
                    type="text"
                    placeholder="Tempat Meninggal"
                    defaultValue={dt.tempat_meninggal}
                    required={
                      formData.status.dataPenduduk !== "none" ? true : false
                    }
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tanggal Dikebumikan</b>
                  </Label>
                  <Datetime
                    inputProps={{
                      "data-testid": "tgl_dikebumikan",
                      placeholder: "Tanggal Dikebumikan",
                      // required: true
                    }}
                    inputId="tgl_dikebumikan"
                    name="tgl_dikebumikan"
                    id="tgl_dikebumikan"
                    locale="id-ID"
                    dateFormat="DD/MM/yyyy"
                    timeFormat={false}
                    input={true}
                    closeOnTab={true}
                    initialValue={new Date(dt.tgl_dikebumikan)}
                    value={new Date(dt.tgl_dikebumikan)}
                    required
                    // required={formData.status.dataPenduduk !== "none" ? true : false}
                    onChange={date => {
                      if (typeof date._isValid !== "undefined") {
                        let tgl = date.format("YYYY-MM-DD");
                        setDt({
                          ...dt,
                          tgl_dikebumikan: new Date(tgl)
                        });
                      }
                    }}
                  />
                </Col>
              </FormGroup>
            </div>
            <FormGroup className="row">
              <Col sm="12">
                <button
                  // href={() => false}
                  data-testid="btnInputKematian"
                  onClick={e => {
                    e.preventDefault();
                    // testing
                    // if (formData.meninggal2 === "none") {
                    // 	if (this.props.getJenisInput) {
                    // 		this.props.getJenisInput("tambah")
                    // 	}
                    // }
                    // else {
                    // 	if (this.props.getJenisInput) {
                    // 		this.props.getJenisInput("hapus")
                    // 	}
                    // }
                    tambahMeninggal();
                  }}
                  className={
                    formData.meninggal2 === "none"
                      ? "btn btn-sm btn-success"
                      : "btn btn-sm btn-danger"
                  }
                >
                  {formData.meninggal2 === "none"
                    ? "Tambah Data Meninggal"
                    : "Hapus Data Meninggal"}
                </button>
              </Col>
            </FormGroup>
          </div>
          <div style={{ display: formData.meninggal2 }}>
            <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Penduduk Meninggal 2</b>
						</div>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="] col-form-label" htmlFor="nik2">
                  <b>NIK Penduduk</b>
                </Label>
                <div data-testid="selectNIK2">
                  <Select
                    inputId="nik2"
                    classNamePrefix="select"
                    onChange={e => {
                      getPenduduk(e, "nik", "meninggal2");
                    }}
                    defaultValue={formData.nik2Stat}
                    value={formData.nik2Stat}
                    name="NIK2"
                    options={formData.frmNik2}
                    placeholder="Pilih NIK"
                    // onInputChange={e => handleInputChangeNIK(e, "nik2")}
                    isClearable
                  />
                </div>
              </Col>
            </FormGroup>
            <div style={{ display: formData.status.dataPenduduk2 }}>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Nama Penduduk</b>
                  </Label>
                  <input
                    className="form-control"
                    id="nama2"
                    type="text"
                    placeholder="Nama Pemohon"
                    value={dt.nama_meninggal2}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tempat Lahir</b>
                  </Label>
                  <input
                    className="form-control"
                    id="tempat_lahir2"
                    type="text"
                    placeholder="Tempat Lahir"
                    value={dt.tempat_lahir_meninggal2}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tanggal Lahir</b>
                  </Label>
                  <input
                    className="form-control"
                    id="tanggal_lahir2"
                    type="text"
                    placeholder="Tanggal Lahir"
                    value={new Date(dt.tanggal_lahir_meninggal2).toLocaleDateString(
                      "id-ID"
                    )}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className=" col-form-label" htmlFor="inputEmail3">
                    <b>Alamat</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_kk3"
                    type="text"
                    placeholder="Alamat"
                    value={dt.alamat_kk3}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className=" col-form-label" htmlFor="inputEmail3">
                    <b>Wilayah</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_meninggal2"
                    type="text"
                    placeholder="Alamat"
                    value={dt.alamat_meninggal2}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tanggal Meninggal</b>
                  </Label>
                  <Datetime
                    inputProps={{
                      "data-testid": "waktu_meninggal2",
                      placeholder: "Tanggal Meninggal",
                      required: formData.status.dataPenduduk2 !== "none"
                    }}
                    inputId="waktu_meninggal2"
                    name="waktu_meninggal2"
                    locale="id-ID"
                    dateFormat="DD/MM/yyyy"
                    timeFormat={false}
                    input={true}
                    closeOnTab={true}
                    initialValue={new Date(dt.waktu_meninggal2)}
                    value={new Date(dt.waktu_meninggal2)}
                    onChange={date => {
                      if (typeof date._isValid !== "undefined") {
                        // let tgl = date.format("YYYY-MM-DD HH:mm:ss");
                        let tgl = date.format("YYYY-MM-DD");
                        setDt({
                          ...dt,
                          waktu_meninggal2: new Date(tgl)
                        });
                      }
                    }}
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Dikebumikan di</b>
                  </Label>
                  <input
                    data-testid="tempat_meninggal2"
                    name="tempat_meninggal2"
                    className="form-control"
                    id="tempat_meninggal2"
                    type="text"
                    placeholder="Tempat Meninggal"
                    defaultValue={dt.tempat_meninggal2}
                    required={
                      formData.status.dataPenduduk2 !== "none" ? true : false
                    }
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tanggal Dikebumikan</b>
                  </Label>
                  <Datetime
                    inputProps={{
                      "data-testid": "tgl_dikebumikan2",
                      placeholder: "Tanggal Dikebumikan",
                      required: formData.status.dataPenduduk2 !== "none"
                    }}
                    inputId="tgl_dikebumikan2"
                    name="tgl_dikebumikan2"
                    locale="id-ID"
                    dateFormat="DD/MM/yyyy"
                    timeFormat={false}
                    input={true}
                    closeOnTab={true}
                    initialValue={new Date(dt.tgl_dikebumikan2)}
                    value={new Date(dt.tgl_dikebumikan2)}
                    onChange={date => {
                      if (typeof date._isValid !== "undefined") {
                        // let tgl = date.format("YYYY-MM-DD HH:mm:ss");
                        let tgl = date.format("YYYY-MM-DD");
                        setDt({
                          ...dt,
                          tgl_dikebumikan2: new Date(tgl)
                        });
                      }
                    }}
                  />
                </Col>
              </FormGroup>
            </div>
          </div>
          <hr />
          <div style={{ display: formData.meninggal }}>
            <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
              <b>Data Ahli Waris</b>
            </div>
                {/* <Label className="col-form-label">
                  <b>Tambah Ahli Waris</b>
                </Label> */}
                <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label">
                    <b>Nik Ahli Waris</b>
                  </Label>
                  {formData.status.ahliWarisManual === "none" || "" ? (
                    <div data-testid="selectNIK3">
                      <Select
                        inputId="nik3"
                        classNamePrefix="select"
                        onChange={e => {
                          getPenduduk(e, "nik", "pengikut");
                        }}
                        defaultValue={formData.nik3Stat}
                        value={formData.nik3Stat}
                        name="NIK3"
                        options={formData.frmNik3}
                        placeholder="Pilih Anggota Keluarga"
                        // onInputChange={e => this.handleInputChangeNIK(e, "nik3")}
                        isClearable
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  <input
                    data-testid="nik_ahli_waris"
                    name="nik_ahli_waris"
                    className="form-control"
                    id="nik_ahli_waris"
                    type={formData.status.ahliWarisManual === "none" || "" ? "hidden" : "text"}
                    pattern="\d{1,16}"
                    onChange={e => handleInputChange(e, "nik_ahli_waris")}
                    maxLength={16}
                    value={dt.nik_ahli_waris}
                    defaultValue={dt.nik_ahli_waris}
                    minLength={16}
                    required={formData.status.formAhliWaris === "none" || "" ? false : true}
                    placeholder="Masukkan NIK Ahli Waris (16 angka)"
                    // defaultValue={dt.detail.nik}
                    // value={dt.detail.nik}
                    // onChange={e => changeInputText(e, "nik_ayah", "ayah")}
                  />
                </Col>
                </FormGroup>
                <div style={{ display: formData.status.ahliWarisManual }}>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label className="col-form-label" htmlFor="inputEmail3">
                        <b>Nama</b>
                      </Label>
                      <input
                        data-testid="nama_ahli_waris"
                        name="nama_ahli_waris"
                        className="form-control"
                        id="nama_ahli_waris"
                        type="text"
                        onChange={e => handleInputChange(e, "nama_ahli_waris")}
                        value={dt.nama_ahli_waris}
                        defaultValue={dt.nama_ahli_waris}
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        // readOnly={formData.formAhliWaris === "" ? false : true}
                        placeholder="Contoh : Toni"
                        //   defaultValue={dt.detail.nama}
                        //   value={dt.detail.nama}
                        //   style={
                        //     formData.formAhliWaris === ""
                        //       ? { backgroundColor: "" }
                        //       : { backgroundColor: "#c9d1d8" }
                        //   }
                        // disabled={formData.formAhliWaris === "" ? false : true}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label className="col-form-label" htmlFor="inputEmail3">
                        <b>Jenis Kelamin</b>
                      </Label>
                      <Select
                        inputId="jk_ahli_waris"
                        data-testid="jk_ahli_waris"
                        name="jk_ahli_waris"
                        // className="form-control"
                        id="jk_ahli_waris"
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        placeholder="Pilih Jenis Kelamin Ahli Waris"
                        // defaultValue={dt.jk_ahli_waris}
                        value={dt.jk_ahli_waris}
                        options={[
                          { label: "Laki-Laki", value: "Laki-Laki" },
                          { label: "Perempuan", value: "Perempuan" }
                        ]}
                        onChange={e => handleSelectChange(e, "jk_ahli_waris")}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label className="col-form-label" htmlFor="inputEmail3">
                        <b>Tanggal Lahir</b>
                      </Label>
                      {/* {formData.formAyah === "" ? ( */}
                      <Datetime
                        inputProps={{
                          "data-testid": "tgl_lahir_ahli_waris",
                          placeholder: "Pilih Tanggal Lahir Ahli Waris",
                          required: requireTanggalAhliWaris()
                        }}
                        inputId="tgl_lahir_ahli_waris"
                        name="tgl_lahir_ahli_waris"
                        locale="id-ID"
                        timeFormat={false}
                        dateFormat="DD/MM/yyyy"
                        input={true}
                        closeOnTab={true}
                        // initialValue={dt.tgl_lahir_ahli_waris}
                        // value={dt.tgl_lahir_ahli_waris}
                        onChange={date => {
                          if (typeof date._isValid !== "undefined") {
                            let tgl = date.format("YYYY-MM-DD");
                            setDt({
                              ...dt,
                              tgl_lahir_ahli_waris: new Date(tgl)
                            });
                          }
                        }}
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label
                        className="col-form-label"
                        htmlFor="tempat_lahir_ahli_waris"
                      >
                        <b>Tempat Lahir</b>
                      </Label>
                      <input
                        data-testid="tempat_lahir_ahli_waris"
                        name="tempat_lahir_ahli_waris"
                        className="form-control"
                        id="tempat_lahir_ahli_waris"
                        type="text"
                        onChange={e =>
                          handleInputChange(e, "tempat_lahir_ahli_waris")
                        }
                        defaultValue={dt.tempat_lahir_ahli_waris}
                        value={dt.tempat_lahir_ahli_waris}
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        // readOnly={formData.formAhliWaris === "" ? false : true}
                        placeholder="Contoh : Jakarta"
                        // style={{ backgroundColor: "#c9d1d8" }}
                      />
                      {/* )} */}
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label
                        className="col-form-label"
                        htmlFor="alamat_ahli_waris"
                      >
                        <b>Alamat</b>
                      </Label>
                      <input
                        data-testid="alamat_ahli_waris"
                        name="alamat_ahli_waris"
                        className="form-control"
                        id="alamat_ahli_waris"
                        type="text"
                        onChange={e =>
                          handleInputChange(e, "alamat_ahli_waris")
                        }
                        defaultValue={dt.alamat_ahli_waris}
                        value={dt.alamat_ahli_waris}
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        placeholder="Masukkan Alamat Ahli Waris"
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label className="col-form-label" htmlFor="pekerjaan">
                        <b>Pekerjaan</b>
                      </Label>
                      <Select
                        inputId="pekerjaan"
                        classNamePrefix="select"
                        onChange={e =>
                          handleSelectChange(e, "pekerjaan_ahli_waris")
                        }
                        // value={dt.detail_surat.data_ibu.pekerjaan_ibu}
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        name="pekerjaan_ahli_waris"
                        id="pekerjaan_ahli_waris"
                        options={formData.frmPkr}
                        // defaultValue={dt.pekerjaan_ahli_waris}
                        value={dt.pekerjaan_ahli_waris}
                        placeholder="Pilih Pekerjaan Ahli Waris"
                        isClearable
                      />
                      {/* )} */}
                    </Col>
                  </FormGroup>
                  <FormGroup className="row">
                    <Col sm="12">
                      <Label className=" col-form-label" htmlFor="inputEmail3">
                        <b>Hubungan Ahli Waris</b>
                      </Label>
                      <Select
                        inputId="shdk_ahli_waris"
                        classNamePrefix="select"
                        name="shdk_ahli_waris"
                        id="shdk_ahli_waris"
                        required={
                          formData.formAhliWaris === "none" ? false : true
                        }
                        value={dt.shdk_ahli_waris}
                        options={formData.frmShdk}
                        onChange={e => handleSelectChange(e, "shdk_ahli_waris")}
                        placeholder="Pilih Hubungan Ahli Waris"
                        isClearable
                        //   placeholder="Contoh : Jalan Sudirman No. 2 Kec. Bandar Sari, Kab. Kampar, Riau"
                        //   defaultValue={dt.detail_surat.data_ayah.alamat_ayah}
                        //   value={dt.detail_surat.data_ayah.alamat_ayah}
                        //   onChange={e =>
                        //     changeInputText(e, "alamat_ayah", "ayah")
                        //   }
                        //   style={
                        //     formData.formAyah === ""
                        //       ? { backgroundColor: "" }
                        //       : { backgroundColor: "#c9d1d8" }
                        //   }
                        //   disabled={formData.formAyah === "" ? false : true}
                      />
                    </Col>
                  </FormGroup>
                  {/* <FormGroup className="row">
                      <Col sm="12">
                        <Label className="col-form-label" htmlFor="inputEmail3">
                          <b>Agama Ayah</b>
                        </Label>
                        {formData.formAyah === "" ? (
                          // || dt.agama_ayah !== ""
                          <div data-testid="selectAgama">
                            <Select
                              inputId="agama_ayah"
                              classNamePrefix="select"
                              onChange={e => {
                                changeSelectValue(e, "agama_ayah", "ayah");
                              }}
                              value={dt.detail_surat.data_ayah.agama_ayah}
                              name="agama_ayah"
                              options={formData.frmAgm}
                              placeholder="Pilih Agama Ayah"
                              isClearable
                            />
                          </div>
                        ) : (
                          <input
                            id="agama_ayah"
                            type="text"
                            className="form-control"
                            readOnly
                            value={
                              dt.detail_surat.data_ayah.agama_ayah
                                ? dt.detail_surat.data_ayah.agama_ayah.label
                                : ""
                            }
                            style={{ backgroundColor: "#c9d1d8" }}
                          />
                        )}
                      </Col>
                    </FormGroup> */}
                  <button
                    type="button"
                    className="btn btn-primary-custom"
                    onClick={tambahwaris}
                    // disabled={formData.status.btnForm}
                  >
                    Simpan
                  </button>
                  {/* <button
						type="button"
						className="ml-2 btn btn-danger"
						// onClick={
						// 	// tutupInputManual(formData.status.ahliWarisManual, formData.status.formAhliWaris)
						// 	// console.log("jaooasdiihugtfytryguhijjihugyftdre")
						// }
						// disabled={formData.status.btnForm}
						>
						Tutup
                  	</button> */}
                </div>

                <small id="emailHelp" className="form-text text-muted mb-3">
                  Data NIK {formData.formAhliWaris === "none" ? "tidak" : ""}{" "}
                  tersedia?{" "}
                  <span
                    style={{ cursor: "pointer", color: "#0000ff" }}
                    onClick={() => {
                      if (formData.formAhliWaris === "none") {
                        if (props.getJenisInput) {
                          props.getJenisInput("manual");
                        }
                      } else {
                        if (props.getJenisInput) {
                          props.getJenisInput("auto");
                        }
                      }
                      dataAhliWaris();
                    }}
                  >
                    Klik disini
                  </span>
                </small>


              {dt.detail.length > 0 ? (
                <>
                  <Label
                    className="col-sm-3 col-form-label"
                    style={{ fontWeight: "700" }}
                  >
                    Daftar Ahli Waris
                  </Label>
                  <Col sm="12" style={{ overflowX: "auto" }}>
                    <table className="table table-bordered table-stripes table-hovered">
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Nama</th>
                          <th>Jenis Kelamin</th>
                          <th>Tempat/Tanggal Lahir</th>
                          <th>Pekerjaan</th>
                          <th>Hubungan Keluarga</th>
                          <th style={{width:"100px"}}>Alamat</th>
                          <th>
                            <i className="fa fa-trash"></i>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {dt.detail.map((val, i) => {
                          let jk = "L";
                          if (val.jenis_kelamin === "Perempuan") {
                            jk = "P";
                          }
                          return (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{val.nama}</td>
                              <td>{jk}</td>
                              <td>
                                {val.tempat_lahir}, {Tanggal(val.tanggal_lahir)}
                              </td>
                              <td>{val.pekerjaan}</td>
                              <td>{val.shdk}</td>
                              <td>{val.alamat_kk}</td>
                              <td>
                                <Button
                                  size="xs"
                                  onClick={() => hapusDetail(i)}
                                  color="danger"
                                  className="btn-icon"
                                >
                                  <i className="fa fa-trash"></i>
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Col>
                </>
              ) : (
                <div className="col-sm-12" style={{ marginTop: "20px" }}>
                  <h6 className="text-center">
                    Belum ada ahli waris yang ditambahkan
                  </h6>
                </div>
              )}
           
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-warning"
            onClick={() => {
              // Tutup modal
              setFormData({
                ...formData,
                status: {
                  ...formData.status,
                  form: false,
                  frmPreviewDraft: false,
									jenis_form: '',
                }
              });
              setIsOpen(false);
            }}
          >
            Tutup
          </button>
          <button
            data-testid="btnSubmitCreate"
            type="submit"
            className="btn btn-primary-custom"
            // disabled={formData.status.btnForm}
          >
            Simpan
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalSuratAhliWaris;
